import { createListenerMiddleware, createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store';
import { changeMessages } from 'store/notifications/slicer';

import { eventsListApi } from './api';

const listenerMiddleware = createListenerMiddleware();

const selectSelf = (state: RootState) => state;
const selectCooperativeId = createSelector(
  selectSelf,
  (state) => state.settings.current_cooperative
);

listenerMiddleware.startListening({
  matcher: eventsListApi.endpoints.readEventMessages.matchFulfilled,
  effect: async (_action, listenerApi) => {
    const cooperativeId = selectCooperativeId(
      listenerApi.getState() as RootState
    );

    if (cooperativeId) {
      listenerApi.dispatch(changeMessages(cooperativeId));
    }
  },
});

export const readEventMessagesMiddleware = listenerMiddleware.middleware;
